import React from 'react'
import type { ComposeComponentVerticalImageCtaFragment } from '../../../.graphql/generated-types'
import { ContentfulImageWithPlaceholder } from '../ContentfulImageWithPlaceholder'

export interface ComposeComponentVerticalImageCTAProps {
  data: ComposeComponentVerticalImageCtaFragment
}

export function ComposeComponentVerticalImageCTA({
  data,
}: ComposeComponentVerticalImageCTAProps) {
  if (data.url && data.image?.imageAsset) {
    const {
      imageAsset: { url: imageUrl, height, width },
      altText,
    } = data.image
    if (!imageUrl || !height || !width) return null
    return (
      <a href={data.url}>
        <ContentfulImageWithPlaceholder
          width={width}
          height={height}
          src={imageUrl}
          alt={altText ?? ''}
        />
      </a>
    )
  }
  return null
}
